import clsx from "clsx";
import { useLayoutEffect } from "react";
import { useWatch } from "react-hook-form";
import CreateableSingleSelect from "components/Form/Select/CreateableSingleSelect";
import { ControlledSelectProps } from "components/Form/Select";
import { useFloatingField } from "./context";
import { sizeStyles } from "./sizeStyles";

interface FloatingCreatableSingleProps extends ControlledSelectProps {
  resourceUrl: string;
}

function FloatingCreatableSingle({ control, name, ...rest }: FloatingCreatableSingleProps) {
  const { setHasValue, hasValue, size } = useFloatingField();
  const styles = sizeStyles[size];
  const value = useWatch({ control, name });

  useLayoutEffect(() => {
    setHasValue(!!value);
  }, [value, setHasValue]);

  // Pass chakraStyles via rest so it overrides CreateableSingleSelect's hardcoded chakraStyles
  // (CreateableSingleSelect spreads {...props} after its own chakraStyles, so ours wins)
  return (
    <div className={clsx("floating-single-select", hasValue && "chakra-react-select--has-value")}>
      <CreateableSingleSelect
        {...rest}
        control={control}
        name={name}
        placeholder=""
        chakraStyles={{
          control: (provided: any) => ({
            ...provided,
            height: styles.inputHeight,
            minHeight: styles.inputHeight,
            maxHeight: styles.inputHeight,
            cursor: "pointer",
            backgroundColor: "transparent",
          }),
          valueContainer: (provided: any) => ({
            ...provided,
            paddingLeft: 0,
            paddingInlineStart: 0,
          }),
          option: (provided: any) => ({
            ...provided,
            color: "fg.muted",
          }),
        }}
      />
    </div>
  );
}

export default FloatingCreatableSingle;
